import { Typography } from '@mui/material';

import { Card } from 'src/components';
import { FieldInput } from 'src/components/FormikComponents';

const CreditNoteReason: FC = () => {
    return (
        <Card gap="24px">
            <Typography fontSize="20px" fontWeight="500" lineHeight="30px" color="#1d1d1b">
                Credit Note Reason
            </Typography>
            <FieldInput name="reason" multiline={true} />
        </Card>
    );
};
export default CreditNoteReason;
